import { Deferred } from '../../logic/deferred';

class AssistantWaitUntilElement {
  static WAIT_UNTIL_ELEMENT_INTERVAL_IN_MS: number = 400;
  static WAIT_UNTIL_ELEMENT_MAX_TRIES: number = 10;
  intervalPromise: NodeJS.Timer;
  private element: string;

  // TODO: internalize waiters array
  public waitUntilElementIsInDOM(
    element: string,
    stopCondition: Function,
    waitForCondition: (element: string) => boolean = null,
    intervalInMS: number = AssistantWaitUntilElement.WAIT_UNTIL_ELEMENT_INTERVAL_IN_MS,
    maxTries: number = AssistantWaitUntilElement.WAIT_UNTIL_ELEMENT_MAX_TRIES,
  ): Promise<NodeListOf<Element>> {
    this.element = element;
    if (this.intervalPromise) {
      this.stopWaiting();
    }

    const deferred = new Deferred<NodeListOf<Element>>();
    let numberOfChecks = 0;
    const elements = document.querySelectorAll<HTMLElement>(element);
    if (
      (!waitForCondition && elements.length) ||
      (waitForCondition && waitForCondition(element))
    ) {
      deferred.resolve(elements);
    } else {
      this.intervalPromise = setInterval(
        () => {
          numberOfChecks++;
          //%% maybe switch to let elements and use the same variable
          const _elements = document.querySelectorAll<HTMLElement>(element);
          if (
            (!waitForCondition && _elements.length) ||
            (waitForCondition && waitForCondition(element)) ||
            stopCondition()
          ) {
            this.stopWaiting();
            deferred.resolve(_elements);
          } else if (numberOfChecks >= maxTries) {
            this.stopWaiting();
            console.error(`assistant waiter: couldn't find ${this.element}`);
            deferred.reject();
          }
        },
        intervalInMS,
        maxTries,
      );
    }
    return deferred.promise;
  }

  public stopWaiting() {
    if (this.intervalPromise) {
      clearInterval(this.intervalPromise);
    }
  }
}

const createWaiter = () => new AssistantWaitUntilElement();

export { createWaiter, AssistantWaitUntilElement };
